// Mirrors backend/src/support/anhaenge.ts (MAX_DATEI_BYTES, ATTACHMENT_TYPES).
// The server decides; this check only saves the user a failed upload.
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const UPLOAD_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.pdf', '.txt', '.csv'];
export const UPLOAD_ACCEPT = UPLOAD_EXTENSIONS.join(',');

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Returns the message to show, or null when the file may be sent. */
export function uploadProblem(file: { name: string; size: number }): string | null {
  const dot = file.name.lastIndexOf('.');
  const extension = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
  if (!UPLOAD_EXTENSIONS.includes(extension)) return 'Dateityp nicht erlaubt. Erlaubt: PNG, JPG, GIF, WebP, PDF, TXT, CSV.';
  if (file.size === 0) return 'Die Datei ist leer.';
  if (file.size > MAX_UPLOAD_BYTES) return `Datei ist zu groß (${formatFileSize(file.size)}). Maximal 10 MB.`;
  return null;
}
